<template>
  <v-layout>
    <v-flex class="search-location-select w-100">
      <v-autocomplete
              v-model="model"
              @keydown="keydownIndividualName"
              @keyup="keyupIndividualName"
              :search-input.sync="search"
              class="g-search-input"
              :items="items"
              :placeholder="$t('products.select_location')"
              item-text="label"
              item-value="id"
              :loading="loading"
              hide-details
              hide-selected
              clearable
              @click:clear="callItBack()"
              solo
              flat
              :ripple="false"
              prepend-inner-icon='icon-location'
              :menu-props="{contentClass: 'select-dropdown'}"
              attach=".location-select"
              :hide-no-data="true"
              :no-filter="noFilter"
      >
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'SearchByLocation',
  data () {
    return {
      noFilter: true,
      locations: [],
      model: null,
      offset: 1,
      loading: false,
      limit: 8,
      search: null,
      apiUrl: process.env.ROOT_API,
      typingTimer: {},
      previousSearchData: {},
      descriptionLimit: 40
    }
  },
  computed: {
    items () {
      return this.locations.map(location => {
        const label = location.label.length > this.descriptionLimit
          ? location.label.slice(0, this.descriptionLimit) + '...'
          : location.label

        return Object.assign({}, location, {label})
      })
    }
  },
  mounted () {
    // Detect when scrolled to bottom.
    this.$nextTick(e => {
      const listElm = document.querySelector('.v-autocomplete__content')
      if (listElm) {
        listElm.addEventListener('scroll', e => {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            this.getIndividualProductsList()
          }
        })
      }
    })
  },
  watch: {
    model (val) {
      this.$emit('changeLocation', val)
      if (!val) {
        this.locations = []
      }
    }
  },
  methods: {
    callItBack () {
      this.$emit('changeLocation')
    },
    keyupIndividualName (e) {
      this.loading = true
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        if (e.target && ((e.target.value && e.target.value.length > 2) || e.target.value.length === 0)) {
          this.offset = 1
          this.locations = []
          this.search = e.target.value
          this.getIndividualProductsList()
          this.$emit('changeLocation')
        } else {
          this.loading = false
        }
      }, 400)
    },
    keydownIndividualName () {
      clearTimeout(this.typingTimer)
    },
    getIndividualProductsList () {
      const searchData = {offset: this.offset, limit: this.limit, search: this.search}
      let _payload = ''
      if (this.search) {
        _payload = `&search=${this.search}&page=${this.offset}&limit=${this.limit}`
      } else {
        this.locations = []
        this.loading = false
        return false
      }

      if (!this.previousSearchData.existItems && this.previousSearchData.offset === this.offset && this.previousSearchData.limit === this.limit && this.previousSearchData.search === this.search) {
        this.loading = false
        return false
      }

      this.$store.dispatch('products/gatAddresses', _payload)
        .then(response => {
          this.previousSearchData = {...searchData}
          this.previousSearchData.existItems = true

          if (response.length === 0) {
            this.$emit('changeLocation', 0)
            this.previousSearchData.existItems = false
          } else {
            this.offset += 1
          }
          response.forEach(location => {
            this.locations.push({id: location.id, label: location.label})
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/sass/desktop/products.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/SearchByLocation.vue